export default __webpack_public_path__ + "static/media/warehouse-solid-full-green.2834c0ea.svg";